import { FC } from 'react';
import classes from '../../asset/css/subscription-detail/one-time-banner.module.css';
import oneTimeBannerBox from '../../asset/images/subscription-detail/onetimebanner-box.png';
export const OneTimeBanner: FC = () => {
  return (
    <div className={classes.banner}>
      <div className={classes.banner_container}>
        <p className={classes.banner_desc}>
          安心してお試しいただけるよう、XOULFUL BOXでは一度きりのご購入も可能となっております。
          <br />
          翌月以降不要であればマイページよりカンタンに削除いただけます。
        </p>
        <div className={classes.banner_imgContainer}>
          <img src={oneTimeBannerBox} className={classes.banner_image_img} />
        </div>
        <div className={classes.banner_btnContainer}>
          <a href={`${document.referrer.replace(/\/$/, '')}/pages/subscription`} target="_parent" className={classes.banner_btn}>
            XOULFUL BOXの詳細はコチラ　&gt;
          </a>
        </div>
      </div>
    </div>
  );
};
